import React, { useEffect, useLayoutEffect } from 'react'
import useNav from '../../../../hooks/useNav'
import { Link, useSearchParams } from 'react-router-dom'
import { Breadcrumb } from '../../../../components/ui/breadcrumb';
import { useHistory } from '../../../../context/HistoryContext';
import { styles } from '../../../../styles/tailwind-config';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table';
import { MoveLeft, Undo2Icon } from 'lucide-react';
import { useBoundStore } from '../../../../zustand';
import { Trans, useLingui } from '@lingui/react/macro'
import { log } from 'console';

const BillOfMaterial = () => {
    const { t } = useLingui()
    const [searchParams, setSearchParams] = useSearchParams();
    const { setNav, nav } = useNav()

    const spareparts = useBoundStore((state) => state.spareparts)
    const interventions = useBoundStore((state) => state.interventions)
    const intervention = interventions?.find((i)=>i.m_iCALLID === parseInt(searchParams.get('callid') || ''))

    useEffect(()=>{
        setNav({...nav, title:t`Bill of materials - callid ${searchParams.get('callid')}`})
    }, [])

  return (
    <div className='p-4'>
        <Breadcrumb items={[{title:<Link to="/" className='underline'><Trans>Startpagina</Trans></Link>}, {title:<Link to="/" className='underline'>Callid {searchParams.get('callid')}</Link>}, {title:<Link to=""><Trans>Bill of materials</Trans></Link>}]}/>
        
        <h1 className={`${styles.h1} mt-2 mb-4`}><Trans>Bill Of Materials</Trans></h1>
        <Table>
            <TableHeader>
                <TableRow>
                    <TableHead><Trans>Beschrijving</Trans></TableHead>
                    <TableHead><Trans>Aantal</Trans></TableHead>
                    <TableHead><Trans>BOM</Trans></TableHead>
                    <TableHead><Trans>PARTID</Trans></TableHead>
                    <TableHead><Trans>PARTID LEV</Trans></TableHead>
                </TableRow>
            </TableHeader>
            <TableBody>
                {(intervention && !Array.isArray(intervention?.m_aBOM) || intervention?.m_aBOM?.length === 0) && 
                <TableRow>
                    <TableCell colSpan={99}><Trans>Geen BOM gevonden</Trans></TableCell>
                </TableRow>
                }

                
                {(intervention && Array.isArray(intervention?.m_aBOM) && intervention?.m_aBOM?.length > 0) &&
                <>
                {intervention?.m_aBOM.map((material)=>{ 
                    console.log(material)
                    const sparepart = spareparts.find((sparepart)=>sparepart?.m_iWISSELSTUKID?.toString() === material?.m_iWISSELSTUKID?.toString())
                    return (
                    <TableRow key={material?.m_iBOMID}>
                        <TableCell>{sparepart?.m_sOMSCHRIJVING}</TableCell>
                        <TableCell>{material?.m_rAANTAL}</TableCell>
                        <TableCell>{material?.m_sEXTERNALID}</TableCell>
                        <TableCell>{sparepart?.m_sBARCODE}</TableCell>
                        <TableCell>{material?.m_sEXTERNALPARTID}</TableCell>
                    </TableRow>
                    )
                })}
                </>
                }
            </TableBody>
        </Table>
    </div>
  )
}

export default BillOfMaterial